import store from "../Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: number) =>
  store.dispatch(appActions.setCurrentPage(pageIndex));

const cards: CardDemoProps[] = [
  {
    title: "the Power of\nSound to Sight",
    text: "Auditory data into visual insights,\nenhance decision-making, efficiency,\nand innovation.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(101),
      endIcon: "arrow-right",
    },
    width: "363px",
    titleStyle: { marginTop: "-3px" },
  },
  {
    title: "INFOSYS TRANSFORMER",
    text: "Unleash the power of advanced\ntechnology for streamlined and\nintelligent document processing.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(201),
      endIcon: "arrow-right",
    },
    width: "363px",
    titleStyle: { marginTop: "-3px" },
  },
  {
    title: "Infosys\nResponsible AI",
    text: "Empower your data scientists and AI\ndevelopers with our automated,\nresponsible AI pipelines.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(301),
      endIcon: "arrow-right",
    },
    width: "363px",
    titleStyle: { marginTop: "-3px" },
  },
  {
    title: "INFOSYS TURF \nOPTIMAZATION",
    text: "Optimize boundaries by intelligently\ngrouping wire centers, minimizing\noverutilization and underutilization. ",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(401),
      endIcon: "arrow-right",
    },
    width: "363px",
    titleStyle: { marginTop: "-3px" },
  },
];

const data = {
  bgVideo: "videos/CORAL_2_1.mp4",
  subtitle: "Select a demo to experience the next ",
  cards: cards,
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
};

export default data;
